import { uncountable } from '@ember-data/request-utils/string'

export function initialize() {
  // Tell the inflector that the plural of "metadata" is "metadata"
  // This is necessary for creating book-library/book-metadata records with mirage
  uncountable('metadata')
  // 'preferences' is already plural, so without this rule Ember Data would
  // singularize the JSON:API type 'dashboard-preferences' to 'dashboard-preference'
  // which doesn't match the model name.
  uncountable('dashboard-preferences')
}

export default {
  name: 'custom-inflector-rules',
  initialize,
}
